<script lang="ts" setup>
import { PropType } from 'vue';
import { Result } from '@/models/results.model';
import { Expense } from '@/models/expense';
import { formatCurrency } from '@/filters/filters';

const { result } = defineProps({
  result: {
    type: Object as PropType<Result<Expense>>,
    required: true,
  },
});
</script>
<template>
  <li class="search-result">
    <router-link :to="`/balance/expense/${result.item.number}`"
      >{{ result.item.number }}
    </router-link>
    (expense)
    <div>
      {{ result.item.lines[0].description }}
      {{ formatCurrency(new Expense(result.item).total) }}
    </div>
  </li>
</template>
